/**
 * SocialYoutubeIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SocialYoutubeIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M9.627 8.35a.75.75 0 0 1 .75 0l5.196 3a.75.75 0 0 1 0 1.3l-5.196 3A.75.75 0 0 1 9.252 15V9a.75.75 0 0 1 .375-.65m1.125 5.35 2.946-1.7-2.946-1.701z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.276 3.07a108 108 0 0 1 3.073.06c.885.03 1.827.076 2.65.146.8.068 1.56.164 2.04.314h.001c1.155.364 1.996 1.396 2.274 2.616l.08.39c.172.958.258 2.212.303 3.24a57 57 0 0 1 .052 1.991l.001.127v.092l-.001.127a57 57 0 0 1-.052 1.991c-.052 1.176-.157 2.646-.383 3.63v.002c-.282 1.221-1.121 2.255-2.276 2.615-.478.15-1.24.246-2.039.314-.823.07-1.765.115-2.65.146a107 107 0 0 1-3.073.06l-.204.002h-.144l-.203-.001a105 105 0 0 1-3.073-.06 55 55 0 0 1-2.65-.147c-.8-.068-1.56-.165-2.04-.314H3.96c-1.155-.365-1.996-1.396-2.274-2.616l-.08-.39c-.171-.958-.258-2.212-.303-3.24a57 57 0 0 1-.052-1.992l-.001-.127v-.092l.001-.127c0-.11.003-.268.006-.463.006-.39.02-.93.046-1.527.052-1.176.158-2.647.384-3.632.28-1.222 1.12-2.255 2.276-2.615.479-.15 1.24-.246 2.039-.314.823-.07 1.766-.115 2.65-.146a108 108 0 0 1 3.073-.06l.203-.002h.144zm-.544 1.5a107 107 0 0 0-3.027.059c-.873.03-1.787.076-2.575.142-.812.07-1.419.156-1.72.25-.563.176-1.08.726-1.263 1.519-.191.837-.293 2.182-.345 3.363a55 55 0 0 0-.051 1.936l-.001.121v.081l.001.121c0 .106.003.259.006.448.006.38.02.907.045 1.488.045 1.034.13 2.192.278 3.026l.068.336c.18.786.694 1.34 1.261 1.52l.282.069c.336.067.83.129 1.439.18.788.067 1.702.113 2.575.143a107 107 0 0 0 3.027.06h.536a106 106 0 0 0 3.03-.06c.872-.03 1.786-.075 2.574-.142.812-.07 1.418-.157 1.719-.25l.104-.038c.521-.207.985-.738 1.157-1.482.191-.837.294-2.18.346-3.362a56 56 0 0 0 .051-1.936l.001-.121v-.081l-.001-.121c0-.106-.003-.26-.006-.45-.006-.38-.02-.905-.045-1.486-.052-1.181-.155-2.525-.346-3.362-.18-.786-.694-1.34-1.261-1.52l-.282-.069a14 14 0 0 0-1.437-.18 54 54 0 0 0-2.575-.143 106 106 0 0 0-3.03-.06z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SocialYoutubeIcon = makeIcon('SocialYoutubeIcon', SocialYoutubeIconSvg)
